import React, { useEffect } from "react"
import { useHistory } from "react-router";
import { getSession, setSession } from "../global";
import Header from "./header";
import Sidebar from "./sidebar";
import './layout.css';
import Loader from '../images/whiteloader.svg'
import { useSelector, useDispatch } from "react-redux";
import { setDestinations } from "../redux/appSlice";
import { getDestinations } from "../services/userservice";
import { IsActiveUser, CheckCODAmountLimit, CheckCODWeightLimit } from "../services/dashboardservice";
import axios from "axios";

const Layout = ({ children }) => {
    const { loading } = useSelector((state) => state.appData);
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(async () => {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        const u = getSession('userInfo');
        const amtLimit = getSession('codAmountLimit');
        const weightLimit = getSession('codWeightLimit');

        const MaxAmt = amtLimit?.length > 0 ? amtLimit[0] : null; 
        const MaxWeight = weightLimit?.length > 0 ? weightLimit[0] : null; 

        if (!u || !u.isPasswordUpdated) {
            history.push('/login');
        } else if(u?.id) {
            const rs = await IsActiveUser(u?.id, source);

            const isValidResponse =
                rs &&
                typeof rs === "object" &&
                !Array.isArray(rs) &&
                Object.keys(rs).length > 0;

            if (isValidResponse) {
                if (rs.sts != 2 && !rs.isActiveUser) {
                    history.push('/login');
                } else if (rs.sts != 2 && rs.passwordChangeTimestamp == null) {
                    alert("Your Password is expired, please change your password.");
                    history.push('/changepassword');
                } else if (rs.sts != 2 && rs.passwordChangeTimestamp != u?.passwordChangeTimestamp) {
                    history.push('/login');
                }
            }
        }
        
        if(MaxAmt != null && MaxAmt?.amount) {
            const rs = await CheckCODAmountLimit(MaxAmt.accountNo, source);
            if(MaxAmt.amount != rs?.amount) {
                setSession('codAmountLimit', [{amount: rs.amount, accountNo: MaxAmt.accountNo}]);
            }
        }

        if(MaxWeight != null && MaxWeight?.weight) {
            const rs = await CheckCODWeightLimit(MaxWeight.accountNo, source);
            if(MaxWeight.weight != rs?.weight) {
                setSession('codWeightLimit', [{weight: rs.weight, accountNo: MaxWeight.accountNo}]);
            }
        }

        getDestinations().then((rs) => {
            if (rs && rs.length > 0)
                dispatch(setDestinations({ data: rs }));
            else dispatch(setDestinations({ data: [] }));
        });

        return () => {
            dispatch(setDestinations({ data: [] }));
            source.cancel('Operation canceled by the user.');
        }
    }, []);

    // useEffect(() => {
    //     const u = getSession('userInfo');
    //     if (!u || !u.isPasswordUpdated) {
    //         history.push('/login');
    //     }
    //     else {
    //         getDestinations().then((rs) => {
    //             if (rs && rs.length > 0)
    //                 dispatch(setDestinations({ data: rs }));
    //             else dispatch(setDestinations({ data: [] }));
    //         });
    //     }
    // }, []);


    return <>
        <div id="app">
            {
                loading &&
                <div id="loader">
                    <img src={Loader} height={80} alt="" />
                    <h2>Please Wait</h2>
                </div>
            }
            <div className="main-wrapper">
                <Header />
                <Sidebar />
                <div className="main-content">
                    {children}
                </div>
                <footer className="main-footer">
                    <div style={{ color: '#6c757d', textAlign: 'center' }}>
                        2025 © M&P Express Logistics (Private) Limited
                    </div>
                </footer>
            </div>
        </div>
    </>
}

export default Layout;